import { apiClient } from '@/core/api/client';

export type MarketingCommunicationAssets = {
  enabled: boolean;
  title: string | null;
  url: string;
  description: string | null;
};

export type MarketingWebinarLink = {
  enabled: boolean;
  url: string;
  buttonLabel: string | null;
  description: string | null;
};

export type MarketingAdvisorAcceleratorLink = {
  enabled: boolean;
  url: string;
  buttonLabel: string | null;
  description: string | null;
};

export type MarketingResourcesData = {
  communicationAssets: MarketingCommunicationAssets | null;
  webinarLink: MarketingWebinarLink | null;
  advisorAcceleratorLink: MarketingAdvisorAcceleratorLink | null;
};

export async function fetchMarketingResources(): Promise<MarketingResourcesData> {
  const res = await apiClient.get<MarketingResourcesData>('/financial-advisors/me/marketing-resources');
  return res.data;
}
